import { useStore } from "../../context";
import { navigate } from "@reach/router";
import React, { useState } from "react";
import { urlAuth, urlGetGrados, urlOpciones, urlRegistroExisteAnai } from "../../utils";
import { httpGet } from "../../servicios";
import Swal from "sweetalert2";
import logoanai from "../../images/logos/logoanai.png";

const AuthIns = () => {
  const { dispatch } = useStore();
  const [user, setUser] = useState("");
  const [passw, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function Login(event) {
    event.preventDefault();
    setLoading(true);
    const data = {
      username: "N" + user,
      password: passw,
    };
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };

    let existenciaUsuarioAnai = await httpGet(urlRegistroExisteAnai + user);
    if (existenciaUsuarioAnai.data.existe) {
      setLoading(false);
      Swal.fire({
        icon: "warning",
        title: "Usuario existente",
        text: "Ya existe como usuario ANAI.",
        confirmButtonColor: "#0d1b3e",
      });
    } else {
      fetch(`${urlAuth}auth/login`, options)
        .then((res) => res.json())
        .then(async (data) => {
          let _opciones = await httpGet(urlOpciones, data.token);
          let _grados = await httpGet(urlGetGrados, data.token);
          if (data.token) {
            dispatch({ type: "SET_OPCIONES", payload: _opciones.data });
            dispatch({ type: "SET_GRADOS", payload: _grados.data });
            dispatch({ type: "SET_TOKEN", payload: data });
            navigate("/inscripcion/list");
          } else {
            Swal.fire({
              icon: "error",
              title: "Error de autenticación",
              text: "Credenciales incorrectas.",
              confirmButtonColor: "#0d1b3e",
            });
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log("Error de promesa:", err);
          Swal.fire({
            icon: "error",
            title: "Error de conexión",
            text: "Credenciales incorrectas o error de servidor.",
            confirmButtonColor: "#0d1b3e",
          });
        });
    }
  }

  return (
    <div className="login-bg">
      <div className="login-card">
        <img src={logoanai} alt="ANAI Logo" className="login-logo" />
        <div className="login-title">Inscripciones</div>
        <div className="login-subtitle">
          Ingreso para aspirantes a cadetes — alumnos nuevos
        </div>

        <form noValidate onSubmit={Login}>
          <div className="modern-input-group">
            <label htmlFor="username">Usuario</label>
            <input
              type="text"
              id="username"
              placeholder="Ingrese su usuario"
              value={user}
              onChange={(e) => setUser(e.target.value)}
              autoFocus
              required
            />
          </div>

          <div className="modern-input-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              placeholder="Ingrese su contraseña"
              value={passw}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>

          <button
            type="submit"
            className="btn-modern btn-primary"
            disabled={loading}
          >
            {loading ? (
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span className="spinner-ring" style={{ width: 22, height: 22, borderWidth: 3 }}></span>
                Ingresando...
              </span>
            ) : (
              "INGRESAR"
            )}
          </button>
        </form>

        <div
          style={{
            marginTop: 20,
            padding: "12px 16px",
            background: "rgba(33, 150, 243, 0.08)",
            borderRadius: 8,
            borderLeft: "4px solid var(--anai-accent)",
            fontSize: "0.85rem",
            color: "var(--anai-text-secondary)",
          }}
        >
          <strong>Nota:</strong> Este proceso es sólo para ASPIRANTE A CADETE, es decir
          ALUMNO NUEVO QUE NO HAYA ESTUDIADO EN LA ANAI.
        </div>

        <div className="modern-copyright">
          {"© " + new Date().getFullYear() + " "}
          <a href="https://anai.edu.ec/" target="_blank" rel="noopener noreferrer">
            Academia Naval Almirante Illingworth
          </a>
          <br />
          <span style={{ fontSize: '0.75rem', color: '#999', marginTop: 4, display: 'inline-block' }}>Diseñado y Desarrollado por Departamento de Sistemas ANAI</span>
        </div>
      </div>
    </div>
  );
};

export default AuthIns;
